import React from "react";
import "../../styles/BoardOfTrustees.css";

const trustees = [
  {
    name: "Mr. Abdulla Ibrahim",
    role: "Managing Trustee",
    img: "/images/trustees/1.-Mr.-Abdulla-Ibrahim-Managing-Trustee-P.A.-Educational-Trust.jpg",
  },
  {
    name: "Mr. Muhammed Shafi",
    role: "Trustee",
    img: "/images/trustees/2.-Mr.-Muhammed-Shafi-Trustee-P.A-Education-Trust.jpg",
  },
  {
    name: "Mr. Abdul Lathif",
    role: "Trustee",
    img: "/images/trustees/3.-Mr.-Abdul-Lathif-Trustee-P.A-Educational-Trust.jpg",
  },
  {
    name: "Mr. Muhammed Ameen Ibrahim",
    role: "Trustee",
    img: "/images/trustees/4.-Mr.-Muhammed-Ameen-Ibrahim-Trustee-P.A-Educational-Trust.jpg",
  },
  {
    name: "Mr. Muhammad Salman Ibrahim",
    role: "Trustee",
    img: "/images/trustees/5.-Mr.-Muhammad-Salman-Ibrahim-Trustee--P.A.-Educational-Trust.jpg",
  },
  {
    name: "Mr. Zubair Ibrahim",
    role: "Trustee",
    img: "/images/trustees/6.-Mr.-Zubair-Ibrahim-Trustee-P.A-Educational-Trust.jpg",
  },
  {
    name: "Mr. Bilal Ibrahim",
    role: "Trustee",
    img: "/images/trustees/7.-Mr.-Bilal-Ibrahim-Trustee-P.A-Educational-Trust.jpg",
  },
  {
    name: "Mr. Adil Ibrahim",
    role: "Trustee",
    img: "/images/trustees/8.-Mr.-Adil-Ibrahim-Trustee-P.A.-Educational-Trust.jpg",
  },
  {
    name: "Trustees along with Founder Chairman Dr. P. A. Ibrahim Haji",
    role: "",
    img: "/images/trustees/Trustees-along-with-fonder-chairman-Dr.-P.-A--Ibrahim-Haji.jpg",
  },
];

const BoardOfTrustees = () => {
  return (
    <div className="trustees-container">
      <h2 className="trustees-heading">BOARD OF TRUSTEES</h2>
      
      <div className="trustees-grid">
        {trustees.map((trustee, index) => (
          <div className="trustee-card" key={index}>
            <img
              src={trustee.img}
              alt={trustee.name}
              className="trustee-image"
            />
            <div className="trustee-name">{trustee.name}</div>
            <div className="trustee-role">{trustee.role}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardOfTrustees;
